
import { Link } from 'react-router-dom';

export default function InvestmentProcess() {
  const steps = [
    {
      number: '01',
      title: 'Explore Opportunities',
      description: 'Browse our curated selection of glamping development projects with detailed financial projections and market analysis.',
      icon: 'ri-search-line'
    },
    {
      number: '02',
      title: 'Due Diligence',
      description: 'Access comprehensive investment materials, site visits, and direct communication with our development team.',
      icon: 'ri-file-text-line'
    },
    {
      number: '03',
      title: 'Invest & Track',
      description: 'Complete your investment securely online and receive regular updates on project progress and financial performance.',
      icon: 'ri-line-chart-line'
    },
    {
      number: '04',
      title: 'Realize Returns',
      description: 'Receive distributions as projects generate revenue and achieve targeted returns through our proven exit strategies.',
      icon: 'ri-money-dollar-circle-line'
    }
  ];

  return (
    <section className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Investment Process</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our streamlined process makes it easy to invest in high-quality glamping developments 
            with transparency and professional management every step of the way.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="relative mb-6">
                <div className="w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${step.icon} text-2xl text-white`}></i>
                </div>
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-white border-2 border-emerald-600 rounded-full flex items-center justify-center">
                  <span className="text-xs font-bold text-emerald-600">{step.number}</span>
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
              <p className="text-gray-600 leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
        <div className="text-center mt-12">
          <Link
            to="/start-investing"
            className="bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
          >
            Start Investing Today
          </Link>
        </div>
      </div>
    </section>
  );
}
